import { useTranslation } from 'react-i18next';

export default function SocialMedia(props) {
  
  //let items = props.content.map((item, index) => {
  //  return <li key={index}>{item}</li>;
  //});
  
  //let list = items.length ? <ul>{items}</ul> : '';
  var Socialbox = [];
  var columns = [];

  const { t, i18n } = useTranslation();

  if (props.content.facebook != null) {
    columns.push(
      <li key='Facebook'><a className="icon-social icon-facebook" target="_blank" href={'https://' + props.content.facebook}></a></li>
    );
  }

  if(props.content.twitter != null)
  {
    columns.push(
      <li key='Twitter'><a className="icon-social icon-x" target="_blank" href={'https://' + props.content.twitter}></a></li>
    );
  }
  if (props.content.instagram != null) {
    columns.push(
      <li key='Instgram'><a className="icon-social icon-instagram" target="_blank" href={'https://' + props.content.instagram}></a></li>
    );
  }

  if (props.content.youtube != null) {
    columns.push(
      <li key='Youtube'><a className="icon-social icon-youtube" target="_blank" href={'https://' + props.content.youtube}></a></li>
    );
  }

  if (props.content.tiktok != null) {
    columns.push(
      <li key='Tiktok'><a className="icon-social icon-tiktok" target="_blank" href={'https://' + props.content.tiktok}></a></li>
    );
  }

  if (props.content.snapchat != null) {
    columns.push(
      <li key='Snapchat'><a className="icon-social icon-snapchat" target="_blank" href={'https://' + props.content.snapchat}></a></li>
    );
  }

  if (props.content.linkedin != null) {
    columns.push(
      <li key='Linkedin'><a className="icon-social icon-linkedin" target="_blank" href={'https://' + props.content.linkedin}></a></li>
    );
  }

  if (props.content.pinterest != null) {
    columns.push(
      <li key='Pinterest'><a className="icon-social icon-pinterest" target="_blank" href={'https://' + props.content.pinterest}></a></li>
    );
  }

  if (props.content.reddit != null) {
    columns.push(
      <li key='Reddit'><a className="icon-social icon-reddit" target="_blank" href={'https://' + props.content.reddit}></a></li>
    );
  }

  if (props.content.wechat != null) {
    columns.push(
      <li key='Wechat'><a className="icon-social icon-wechat" target="_blank" href={'https://' + props.content.wechat}></a></li>
    );
  }

  if (props.content.tumblr != null) {
    columns.push(
      <li key='Tumblr'><a className="icon-social icon-tumblr" target="_blank" href={'https://' + props.content.tumblr}></a></li>
    );
  }

  
  if(columns.length != 0)
  {
    Socialbox.push(
      <h3 className="organization__info-title">{t('socialmedia')}</h3>
      
    );
  }

  return(
    <div className="organization__info organization__social">
      {Socialbox}
      <ul>
        {columns}
      </ul>
    </div>
  );
}
